export var PersistenceKey;
(function (PersistenceKey) {
    PersistenceKey["ItemListController"] = "selected-items-controller";
    PersistenceKey["NavigationController"] = "navigation-controller";
})(PersistenceKey || (PersistenceKey = {}));
